<template>
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <BasicCell :span="3" />
    <BasicCell
      :span="4"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="id"
      />
      <span>Numéro</span>
    </BasicCell>
    <BasicCell
      :span="2"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="dispositif"
      />
      <span>Disp.</span>
    </BasicCell>
    <BasicCell
      :span="4"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="sousDispositif"
      />
      <span>Sous disp.</span>
    </BasicCell>
    <BasicCell
      :span="5"
      extra-class="elem--sort"
    >
      <span>Formation</span>
    </BasicCell>
    <BasicCell
      :span="2"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="start"
      />
      <span>Début</span>
    </BasicCell>
    <BasicCell
      :span="2"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="end"
      />
      <span>Fin</span>
    </BasicCell>
    <BasicCell :span="6">
      <span>Entreprise</span>
    </BasicCell>
    <BasicCell :span="3">
      <span>Stagiaire(s)</span>
    </BasicCell>
    <BasicCell
      :span="3"
      extra-class="elem--clickable elem--sort"
    >
      <BasicSort
        v-model="modelValue"
        name="statut"
      />
      <span>Statut</span>
    </BasicCell>
    <BasicCell :span="1" />
    <BasicCell :span="1" />
  </div>
</template>

<script setup lang="ts">
  import BasicCell from '@designSystem/components/basic/cell/BasicCell.vue';

  const modelValue = defineModel<string>()
</script>
